import { _async_generator } from "./_async_generator.js";

export function _wrap_async_generator(fn) {
    return function() {
        return new _async_generator(fn.apply(this, arguments));
    };
}
export { _wrap_async_generator as _ };
